<div class="token-container">
    <div class="tokens" [class.canceled]="canceled">
        {{ count }}
        <ion-icon src="assets/icon/token.svg"></ion-icon>
    </div>
</div>
